import { Typography } from "@mui/material";
import { t } from "i18next";

export const Copyright = () => (
  <Typography
    variant="body2"
    color="textSecondary"
    align="center"
    sx={{ userSelect: "none" }}
  >
    {t("home.copyright", { year: new Date().getFullYear() })}
  </Typography>
);
